<template>
  <div>
    <CcfpModal
      v-if="showModal"
      :price="price"
      @close="closeModal"
    />
    <div
      v-if="isCcfp"
      class="ccfp-offer-wrapper small"
      :class="{
        'margin-top-xxs margin-bottom-xxs small': !isProductPerksEnabled,
        'large': isProductPerksEnabled
      }"
    >
      <span v-if="seatEligible">
        <strong>{{ targetPlan.pricePerMonth }}/mo.*</strong> suggested payments for
        <strong>{{ targetPlan.ticketTermCode }}-months</strong>
        totaling <strong> {{ formattedValue }}</strong> with {{ brand }} Card.
      </span>
      <span v-else>
        <strong>{{ targetPlan?.ticketTermCode }}-month financing</strong> with {{ brand }} Card.
      </span>
      <span v-if="!isProductPerksEnabled">*</span>
      <button
        v-if="!isProductPerksEnabled"
        class="link-sm"
        @click="openCcfpModal"
      >
        Learn more
      </button>
    </div>
  </div>
</template>

<script setup>
import {
  ref, defineAsyncComponent, toRef, watch,
} from 'vue';
import { ccfp } from 'config';
import { useCcfp } from '../composables/useCcfp';
import useModal from '../../../composables/useModal';

const CcfpModal = defineAsyncComponent(() => import(/* webpackChunkName: 'CcfpModal' */ './CcfpModal'));

const props = defineProps({
  price: {
    type: Object,
    required: true,
  },
  isModalOpen: {
    type: Boolean,
    default: false,
  },
  isProductPerksEnabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['open-ccfp-modal', 'close-ccfp-modal']);

const showModal = ref(false);
const { brand } = ccfp;
const { open } = useModal();

const {
  isCcfp, seatEligible, targetPlan, formattedValue,
} = useCcfp(toRef(props, 'price'));

const openCcfpModal = () => {
  showModal.value = true;
  open('ccfp-overlay');
  emit('open-ccfp-modal');
};

const closeModal = () => {
  showModal.value = false;
  emit('close-ccfp-modal');
};

watch(() => props.isModalOpen, (isModalOpen) => {
  if (isModalOpen) {
    openCcfpModal();
  }
});
</script>
